// extracted by mini-css-extract-plugin
module.exports = {"base":"src-Modal-base-1e7bae77","shadow":"src-Modal-shadow-c8b3763e","inContainer":"src-Modal-inContainer-a8cead42","top":"src-Modal-top-9fca4eb1","left":"src-Modal-left-cc206cc2"};